/**
 * Description  :
 * Version      : 1.0.0
 * Author       : Luoye
 * Date         : 2022-08-26 14:10:55
 * LastEditors  : Luoye
 * FilePath     : /namibox_client_web/src/common/hooks/useNativeChangeTitle.ts
 * Copyright (C) 2022 rose. All rights reserved.
 */
import { useEffect } from 'react';
import { getBrowser } from 'SRC/common/utils/appUtils';
function useNativeChangeTitle(title: string, view_name: string) {
  useEffect(() => {
    const { browser } = getBrowser();
    if (['namibox', 'aiclass'].includes(browser)) {
      setTimeout(() => {
        window.jssdk.appReady(() => {
          window.jssdk.send({
            command: 'changetitle',
            title,
            view_name: view_name || '',
          });
        });
      }, 300);
    } else {
      window.document.title = title;
    }
  }, [title]);
}

export default useNativeChangeTitle;
